<template>
  <div
    :class="{
      'mobile-overlay': false,
      search: search,
    }"
  >
    <div
      :class="[
        joinClasses('form', modifiers),
        'form form--flat form--margin-bottom',
      ]"
    >
      <FormRow>
        <div class="input input--light input--flat input--search">
          <div
            :class="{
              input__prefix: true,
              'input__prefix--hilight': search,
            }"
          >
            <UseSvg
              class="icon"
              name="search"
            />
          </div>
          <input
            ref="searchInput"
            v-model="search"
            :aria-label="placeholder"
            :placeholder="placeholder"
            @input="updateSearch"
          >
          <button
            v-if="search"
            class="input__clear"
            type="button"
            @click="clearSearch"
          >
            <UseSvg
              :aria-label="$t('general.close_search')"
              :class="{ icon: true, 'icon--small': true }"
              :name="'close_circle_16'"
            />
          </button>
        </div>
      </FormRow>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import joinClasses from '@/functions/join_classes';
import onEscapePressed from '@/functions/on_escape_pressed';
import UseSvg from '@/components/generic/use_svg.vue';
import FormRow from '@/components/form/row.vue';

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
  placeholder: { type: String, default: '' },
  modelValue: { type: String, default: null },
  modifiers: { type: Array, default: () => ['radius'] },
});

const searchInput = ref(null);
const search = ref('');

watch(props, () => {
  if (!props.modelValue) {
    return search.value = null;
  }

  return search.value = props.modelValue;
});

onEscapePressed(clearSearch);

function updateSearch() {
  emit('update:modelValue', search.value);
}

function clearSearch() {
  search.value = '';
  emit('update:modelValue', null);
}
</script>
